<template>
  <li>
    <div class="d-flex gap-3">
      <div class="comment-body col">
        <div class="d-flex gap-3 align-items-center mb-2">
          <div>
            <div class="comment-user">
              <img
                :src="(reply.author || {}).avatar_url ? (reply.author || {}).avatar_url : require('@/assets/img_avatar.png')"
                alt="user image" />
            </div>
          </div>
          <div class="col">
            <div class="d-flex gap-2 flex-wrap">
              <h6 class="text-info">{{ (reply.author || {}).user_name }}</h6>
              <small class="m-0 text-muted" v-if="(reply.author || {}).grade"> - {{ (reply.author || {}).grade
              }}</small>
            </div>
          </div>
        </div>
        <div class="comment-content">
          <p class="m-0">{{ reply.comment }}</p>
        </div>
        <div class="d-flex gap-2 flex-wrap">
          <p class="comment-footer m-0">{{ reply.created_date }}</p>
        </div>
      </div>
      <div class="comment-reply-action">
        <button class="delete-btn" @click.prevent="deleteCurrentItem(reply, 'reply')"><i
            class="fas fa-trash"></i></button>
      </div>
    </div>
  </li>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'SingleReplyItem',
  props: {
    reply: {
      type: Object,
      default: Object,
    },
  },
  created() {
    console.log(this.reply)
  },
  methods: {
    ...mapActions('ViewVideoModule', ['deleteItem']),
    deleteCurrentItem(item, type) {
      this.deleteItem({
        type,
        item,
        path: this.$route.path,
      });
    },
  },
};
</script>
